import IssuanceTable from './IssuanceTable.jsx'

function TeamAssets() {
  return (
    <>
      <div className='d-flex'>
        <div className='d-flex flex-wrap flex-stack mb-6'>
          <h3 className='fw-bolder my-2'>Asset Issuance</h3>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <IssuanceTable />
      </div>
    </>
  )
}

export default TeamAssets
